import React, { useState } from 'react';

import { Alert, Box, Button, CircularProgress, Grid, Stack, Typography } from '@mui/material';
import KpiComponent from '@/components/Base/KpiComponent';
import { useConsolidationSummary } from '@/features/dashboard/api/getConsolidationSummary.ts';
import CurrencyFormat from '@/utils/CurrencyFormat.ts';
import dayjs from 'dayjs';
import ImportCountDefault from '@/components/Base/ImportCountDefault';
import TableHeaderCustom from '@/components/Base/TableHeaderCustom';
import { ArrowBack } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import {
  getConsolidationSummaryStudents,
  useConsolidationSummaryStudents,
} from '@/features/dashboard/api/getConsolidationSummaryStudents';
import LoadingChart from '@/features/dashboard/components/LoadingChart';
import LoadingSummary from '@/features/dashboard/components/LoadingSummary';
import PeriodFilterDash from '@/components/Base/PeriodFilterDash';
import { TitlePages } from '@/components/Base/TitlePage';
import { useInadimplenciaHistoricalOverview } from '@/features/inadimplencia/api/getInadimplenciaHistoricalOverview';
import { useInadimplenciaKpis } from '@/features/inadimplencia/api/getInadimplenciaHistorical';

const generateLastYears = (numYears) => {
  const currentYear = dayjs().year();
  return Array.from({ length: numYears }, (_, index) => currentYear - index).reverse();
};

export const InadimplenciaConfiguracoesAvancadas = ({ routeBack }) => {
  const startDate = dayjs().startOf('year').format('YYYY-MM-DD');
  const endDate = dayjs().endOf('month').format('YYYY-MM-DD');

  const [open, setOpen] = useState(false);
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  // const { data: summary, isError, refetch, isFetching, isFetched } = useConsolidationSummary();
  
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [listYears, setListYears] = useState(generateLastYears(5));

  const daysDiff = dayjs(selectedEndDate).diff(dayjs(selectedStartDate), 'day') || null;


  const filters = {
    ...(selectedYear && { year: selectedYear }),
    ...(selectedMonth && { month: selectedMonth }),
  };

  const { data: summary, isError, refetch, isFetching, isFetched } = useInadimplenciaHistoricalOverview(filters);

  const {
    data: summaryKpis,
    // isError,
    // refetch,
    isFetching: isFetchingKpis,
    isFetched: isFetchedKpis,
  } = useInadimplenciaKpis({ year: selectedYear, month: selectedMonth });

  const {
    data,
    isFetching: isFetchingStudents,
    isFetched: isFetchedStudents,
  } = useConsolidationSummaryStudents(filters);

  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
  };

  const onApplyFilter = (selectedYear: number) => {
    setOpen(!!selectedYear);
  };

  return (
    <>
      <ImportCountDefault open={open} handleClose={handleClose} />

      <Stack flexDirection={'row'} alignItems={'center'} justifyContent={'space-between'}>
      <Stack flexDirection={'row'} alignItems={'center'}>
          <ArrowBack sx={{  cursor: 'pointer' }} onClick={() => navigate(routeBack)} />
          <TitlePages title={'Inadimplência por aluno'} />
        </Stack>
      </Stack>

      <Box
        padding={'15px'}
        sx={{
          border: '1px solid rgba(176, 176, 176, 1)',
          background: '#fff',
          borderRadius: '14px',
        }}
      >
        {isError && (
          <Alert
            severity="error"
            action={
              <Button
                color="inherit"
                size="small"
                onClick={() => {
                  refetch();
                }}
              >
                Atualizar
              </Button>
            }
          >
            Não foi possível carregar as informações!
          </Alert>
        )}

        {isFetchedKpis && (
          <Stack flexDirection={'row'} gap={'8px'}>
            <Stack
              flexDirection="row"
              maxWidth="100%"
              gap="8px"
              style={{
                overflowX: 'auto',
                scrollBehavior: 'smooth',
                scrollbarWidth: 'thin',
                scrollbarColor: '#888 #f1f1f1',
              }}
            >
              <KpiComponent
                title={'Inadimplência'}
                value={CurrencyFormat.format(summary?.debits_in_year)}
                tooltipText={'Valor acumulado de todos os boletos inadimplentes no ano atual.'}
                style={{minWidth: '160px'}}
              />
              <KpiComponent
                title={'Quantidade de alunos em débito'}
                value={summary?.students_in_debit}
                tooltipText={'Quantidades de alunos com pelo menos um boleto em atraso no ano atual.'}
                style={{minWidth: '160px'}}
              />
              <KpiComponent
                title={'Quantidades de contas inadimplência'}
                value={`${summary?.debits_percentual}%`}
                tooltipText={'Relaciona Total a receber no ano e Total de boletos atrasados no ano corrente.'}
                style={{minWidth: '160px'}}
              />
            </Stack>
          </Stack>
        )}
        {isFetchingKpis && !summaryKpis && <LoadingSummary />}

        <Box marginTop={'10px'} marginBottom={'25px'}>
          <PeriodFilterDash
            startDate={selectedStartDate}
            endDate={selectedEndDate}
            onStartDateChange={setSelectedStartDate}
            onEndDateChange={setSelectedEndDate}
            refetchDashboard={() => console.log('teste')}
            listYears={listYears}
            setSelectedYear={setSelectedYear}
            setSelectedMonth={setSelectedMonth}
            selectedYear={selectedYear}
            selectedMonth={selectedMonth}
            showPeriodFilter={false}
          />
        </Box>

        <LoadingChart loading={isFetchingStudents} />
        {!isFetchingStudents && data && (
          <TableHeaderCustom
            data={data.students || []}
            toBack={
              routeBack === '/inadimplencia'
                ? '/inadimplencia-historico-percentual'
                : '/inadimplencia-historico-percentual-visao'
            }
          />
        )}
      </Box>
    </>
  );
};
